/* RESPONSIBLE TEAM: team-ai-insights */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export default class OptimizeFinRoute extends Route {
  @service declare router: RouterService;

  async beforeModel() {
    this.router.transitionTo('apps.app.automation.fin-ai-agent.analyze.optimize-suggestions');
  }
}
